function EmptyFeed() {
  return (
    <div className="empty-feed" aria-describedby="empty-feed">
      <div className="empty-feed__image">
        <img src="/images/feed-empty.svg" alt="Empty feed" id="empty-feed" />
      </div>
    </div>
  );
}

export default EmptyFeed;
